import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {BrandComponent} from "./brand.component";
import {BrandService} from "../services/brand.service";

const routes: Routes = [
  {
    path: '', component: BrandComponent,
  }
];

@NgModule({
  imports: [ RouterModule.forChild(routes)],
  exports: [ RouterModule ],
  providers: [
    BrandService,
   ]
})
export class BrandRoutingModule {
  static components = [ BrandComponent];
}
